
const t=document.getElementById('ticker');if(t){t.innerHTML+=t.innerHTML}
const hd=document.getElementById('siteHeader');
addEventListener('scroll',()=>hd.classList.toggle('scrolled',scrollY>10),{passive:true});
const car=document.getElementById('carousel');
if(car){document.querySelectorAll('.car-btn').forEach(b=>b.addEventListener('click',()=>{
  car.scrollBy({left:(parseInt(b.dataset.dir))*(car.querySelector('.card').offsetWidth+22)*2,behavior:'smooth'});
}))}
const mainImg=document.getElementById('pdpMain');
if(mainImg){document.querySelectorAll('.pdp-thumbs button').forEach(b=>b.addEventListener('click',()=>{
  document.querySelectorAll('.pdp-thumbs button').forEach(x=>x.classList.remove('sel'));
  b.classList.add('sel');mainImg.src=b.querySelector('img').src.replace('width=300','width=1400');
}))}
document.querySelectorAll('.qty').forEach(q=>{
  const inp=q.querySelector('input');
  q.querySelectorAll('button').forEach(b=>b.addEventListener('click',()=>{
    inp.value=Math.max(1,parseInt(inp.value||1)+parseInt(b.dataset.d));
  }));
});
const io=new IntersectionObserver(es=>es.forEach(e=>{if(e.isIntersecting){e.target.classList.add('in');io.unobserve(e.target)}}),{threshold:.12});
document.querySelectorAll('.reveal').forEach(el=>io.observe(el));

/* mobile drawer */
const burger=document.getElementById('burger');
if(burger){
  const open=v=>document.body.classList.toggle('drawer-open',v);
  burger.addEventListener('click',()=>open(true));
  document.getElementById('drawerClose').addEventListener('click',()=>open(false));
  document.getElementById('drawerVeil').addEventListener('click',()=>open(false));
  document.querySelectorAll('#drawer a').forEach(a=>a.addEventListener('click',()=>open(false)));
  addEventListener('keydown',e=>{if(e.key==='Escape')open(false)});
}

/* bundle builder */
const bgrid=document.getElementById('builderGrid');
if(bgrid){
  const bar=document.getElementById('summaryBar'), RATE=0.15;
  const fmt=x=>'$'+x.toFixed(2);
  function refresh(){
    const on=[...bgrid.querySelectorAll('.b-card.on')];
    const rrp=on.reduce((s,c)=>s+parseFloat(c.dataset.price),0);
    const qualifies=on.length>=3;
    const save=qualifies?rrp*RATE:0;
    document.getElementById('sumN').textContent=on.length+(on.length===1?' product':' products');
    document.getElementById('sumRrp').textContent=qualifies?fmt(rrp):'';
    document.getElementById('sumSave').textContent=qualifies?('You save '+fmt(save)+' (15%)'):(on.length?('Add '+(3-on.length)+' more to unlock 15% off'):'');
    document.getElementById('sumTotal').textContent=fmt(rrp-save);
    bar.classList.toggle('show',on.length>0);
  }
  bgrid.addEventListener('click',e=>{
    const c=e.target.closest('.b-card');
    if(c){c.classList.toggle('on');refresh();}
  });
  document.querySelectorAll('[data-preset]').forEach(b=>b.addEventListener('click',()=>{
    const set=b.dataset.preset.split(',');
    bgrid.querySelectorAll('.b-card').forEach(c=>c.classList.toggle('on',set.includes(c.dataset.handle)));
    refresh();
  }));
  refresh();
}

/* glossary filter */
const gs=document.getElementById('glossSearch');
if(gs){gs.addEventListener('input',()=>{
  const q=gs.value.trim().toLowerCase();
  document.querySelectorAll('.gloss-item').forEach(d=>{
    d.style.display=(!q||d.textContent.toLowerCase().includes(q))?'':'none';
  });
})}


/* ============ Shopify AJAX cart ============ */
const CATALOG={"toiletry-bag": ["Collection Travel Bag", 19.95, "https://cdn.shopify.com/s/files/1/0603/2569/1599/files/studio_product_shot_clean_minimal_scene_a_single_986e6588-2c0a-4f37-9be0-727c6fdf20ce.jpg", "Accessory", 43556278042831], "mummas-soak": ["Mumma's Soak", 26.95, "https://cdn.shopify.com/s/files/1/0603/2569/1599/files/Mamave_mumma_s_soak_front.png", "For Mum \u00b7 250g", 44212785414351], "mummas-scrub": ["Mumma's Scrub", 36.95, "https://cdn.shopify.com/s/files/1/0603/2569/1599/files/Mamave_mumma_s_scrub_front.png", "For Mum \u00b7 250g", 44282652197071], "bubbas-wash": ["Bubba's Wash", 29.95, "https://cdn.shopify.com/s/files/1/0603/2569/1599/files/Mamavebubba_swash_front.png", "For Bub \u00b7 250mL", 41454411448527], "mamave-gift-card": ["Gift Card", 30.0, "https://cdn.shopify.com/s/files/1/0603/2569/1599/files/Mamave_Gift_Cards-01_cf21a306-9fca-4a29-8379-bd3494d16294.jpg", "Gift Card \u00b7 $30\u2013$200", 40720910418127], "bubbas-moisturiser": ["Bubba's Moisturiser", 39.95, "https://cdn.shopify.com/s/files/1/0603/2569/1599/files/Mamavebubba_smoisturiser_front.png", "For Bub \u00b7 250mL", 41454409875663], "mummas-moisturiser": ["Mumma's Moisturiser", 44.95, "https://cdn.shopify.com/s/files/1/0603/2569/1599/files/Mamavemumma_smoisturiser_front.png", "For Mum \u00b7 250mL", 41454408630479], "bubbas-barrier-cream": ["Bubba's Barrier Cream", 35.95, "https://cdn.shopify.com/s/files/1/0603/2569/1599/files/MamaveBubbaBarrierCream_Front.png", "For Bub \u00b7 100mL", 41454405353679], "mummas-oil": ["Mumma's Oil", 42.95, "https://cdn.shopify.com/s/files/1/0603/2569/1599/files/Mamavemumma_soil_front.png", "For Mum \u00b7 100mL", 40851903709391], "bubbas-massage-oil": ["Bubba's Massage Oil", 34.95, "https://cdn.shopify.com/s/files/1/0603/2569/1599/files/Mamavebubba_smassageoil_front.png", "For Bub \u00b7 100mL", 40788380451023]};           // handle -> [name, price, img, kind, variantId]
const FREE_SHIP=75;
const fmtC=x=>'$'+x.toFixed(2);
function cartOpen(v){document.body.classList.toggle('cart-open',v);if(v){document.body.classList.remove('drawer-open');document.body.classList.remove('wish-open')}}
let CART={items:[],item_count:0,total_price:0};
async function syncCart(){try{CART=await (await fetch('/cart.js')).json();renderCart();syncGiftNote();}catch(e){}}
function renderCart(){
  const items=document.getElementById('cartItems'); if(!items)return;
  const sub=CART.total_price/100, count=CART.item_count;
  items.innerHTML=CART.items.length?CART.items.map(it=>`
    <div class="ci" data-key="${it.key}"><img src="${it.image||''}&width=200" alt="">
      <div class="mid"><span class="n">${it.product_title.replace('Mamave - ','').replace(/\s*\(.*?\)\s*$/,'')}</span>
      ${it.selling_plan_allocation?`<span style="display:block;font-size:11.5px;color:var(--terracotta);font-weight:600;margin:-4px 0 6px">&#8635; ${it.selling_plan_allocation.selling_plan.name}</span>`:''}
      <span class="qty"><button data-cq="-1">&minus;</button><i>${it.quantity}</i><button data-cq="1">+</button></span></div>
      <div class="right"><button class="rm" aria-label="Remove">&#10005;</button><span class="p">${fmtC(it.final_line_price/100)}</span></div></div>`).join(''):
  `<div class="cart-empty"><p>Your cart is empty, mumma.</p>
   <svg class="squig" viewBox="0 0 64 12" aria-hidden="true"><path d="M2 8c5-6 9-6 14 0s9 6 14 0 9-6 14 0 9 6 14 0"/></svg></div>`;
  document.getElementById('cartCount').textContent=count;
  document.getElementById('cartTotal').textContent=fmtC(sub);
  document.getElementById('cartCountLabel').textContent=count?`Subtotal (${count} item${count>1?'s':''})`:'Subtotal';
  const fill=document.getElementById('shipFill'),lab=document.getElementById('shipLabel');
  const pct=Math.min(100,sub/FREE_SHIP*100);
  fill.style.width=pct+'%';fill.classList.toggle('done',sub>=FREE_SHIP);
  lab.innerHTML=sub>=FREE_SHIP?'You’ve unlocked <b>free shipping</b>!':(sub>0?`You are <b>${fmtC(FREE_SHIP-sub)}</b> away from free shipping`:`Free shipping on orders over $${FREE_SHIP}`);
  const inCart=new Set(CART.items.map(i=>i.handle));
  const sug=Object.keys(CATALOG).filter(h=>!inCart.has(h)).slice(0,2);
  const up=document.getElementById('cartUpsell');
  up.innerHTML=(CART.items.length&&sug.length)?
    `<h4>Complete the ritual</h4><p>Loved together, from bump to bub.</p>`+sug.map(h=>{
      const [name,price,img]=CATALOG[h];
      return `<div class="up"><img src="${img}?width=140" alt=""><div class="mid"><b>${name}</b><i>${fmtC(price)}</i></div><button data-add="${h}">add</button></div>`;
    }).join(''):'';
}
async function addToCart(h,q,vid,sp){
  let v=vid||(CATALOG[h]&&CATALOG[h][4]);
  if(!v){try{const pd=await (await fetch('/products/'+h+'.js')).json();v=pd.variants[0].id}catch(e){}}
  if(!v)return;
  const item={id:v,quantity:q||1}; if(sp)item.selling_plan=sp;
  await fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({items:[item]})});
  await syncCart(); cartOpen(true);
}
async function changeLine(key,q){
  await fetch('/cart/change.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({id:key,quantity:q})});
  await syncCart();
}
document.addEventListener('click',e=>{
  const vc=e.target.closest('.variant-chip');
  if(vc){document.querySelectorAll('.variant-chip').forEach(c=>c.classList.remove('active'));vc.classList.add('active');
    const f=document.querySelector('.pdp-info input[name=id]'); if(f)f.value=vc.dataset.vid;
    const pp=document.getElementById('pdpPrice'); if(pp)pp.textContent=vc.dataset.vprice;
    const bp=document.getElementById('pdpAddPrice'); if(bp)bp.textContent=vc.dataset.vprice;return}
  const add=e.target.closest('[data-add]');
  if(add){e.preventDefault();e.stopPropagation();
    const info=add.closest('.pdp-info');
    const qi=document.querySelector('.pdp-info .qty input');
    const q=info&&qi?parseInt(qi.value)||1:1;
    const vidInput=info?info.querySelector('input[name=id]'):null;
    const spInput=info?info.querySelector('[name=selling_plan]'):null;
    const sp=spInput&&spInput.value?spInput.value:null;
    addToCart(add.dataset.add,q,vidInput?vidInput.value:null,sp);return}
  const qb=e.target.closest('.quick-buy');
  if(qb){const c=qb.closest('.card');if(c&&c.dataset.handle){e.preventDefault();addToCart(c.dataset.handle,1);return}}
  const cq=e.target.closest('[data-cq]');
  if(cq){const ci=cq.closest('.ci');const it=CART.items.find(i=>i.key===ci.dataset.key);
    if(it)changeLine(it.key,Math.max(0,it.quantity+parseInt(cq.dataset.cq)));return}
  const rm=e.target.closest('.ci .rm');
  if(rm&&!rm.closest('.wish-drawer')){changeLine(rm.closest('.ci').dataset.key,0);return}
});
/* gift note: saved to the Shopify cart note so it lands on the order */
const gnBox=document.getElementById('giftNote'), gnText=document.getElementById('giftNoteText'),
      gnSave=document.getElementById('giftNoteSave'), gnStatus=document.getElementById('giftNoteStatus');
let gnCard='';
function syncGiftNote(){if(!gnText)return;if(CART.note){gnText.value=CART.note;if(gnBox)gnBox.open=true;}
  const a=CART.attributes&&CART.attributes['Gift card'];
  if(a){gnCard=a;if(gnBox)gnBox.open=true;}
  document.querySelectorAll('[data-gcard]').forEach(b=>b.classList.toggle('on',b.dataset.gcard===gnCard));}
document.addEventListener('click',e=>{const c=e.target.closest('[data-gcard]');if(!c)return;
  gnCard=gnCard===c.dataset.gcard?'':c.dataset.gcard;
  document.querySelectorAll('[data-gcard]').forEach(b=>b.classList.toggle('on',b.dataset.gcard===gnCard));});
if(gnSave){gnSave.addEventListener('click',async()=>{
  gnSave.disabled=true;gnStatus.textContent='Saving\u2026';
  try{await fetch('/cart/update.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({note:gnText.value.trim(),attributes:{'Gift card':gnText.value.trim()?gnCard:''}})});
    gnStatus.textContent=gnText.value.trim()?'Saved with your order':'Note removed';
  }catch(e){gnStatus.textContent='Could not save, try again';}
  gnSave.disabled=false;setTimeout(()=>{gnStatus.textContent=''},3500);});}
const cartBtn=document.getElementById('cartBtn');
if(cartBtn){cartBtn.addEventListener('click',()=>cartOpen(true));
  document.getElementById('cartClose').addEventListener('click',()=>cartOpen(false));
  document.getElementById('drawerVeil').addEventListener('click',()=>cartOpen(false));
  addEventListener('keydown',e=>{if(e.key==='Escape')cartOpen(false)});
  syncCart();}
const addBundle=document.getElementById('addBundle');
if(addBundle){addBundle.addEventListener('click',async e=>{e.preventDefault();
  const items=[...document.querySelectorAll('#builderGrid .b-card.on')]
    .map(c=>({id:CATALOG[c.dataset.handle]&&CATALOG[c.dataset.handle][4],quantity:1}))
    .filter(i=>i.id);
  if(!items.length)return;
  await fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({items})});
  await syncCart(); cartOpen(true);});}

/* help-centre FAQ filter */
const fs=document.getElementById('faqSearch');
if(fs){
  fs.addEventListener('input',()=>{
    const q=fs.value.trim().toLowerCase();
    document.querySelectorAll('.faq-groups details.faq').forEach(d=>{
      d.style.display=(!q||d.textContent.toLowerCase().includes(q))?'':'none';
    });
    document.querySelectorAll('.faq-groups .faq-grp').forEach(g=>{
      g.style.display=[...g.querySelectorAll('details.faq')].some(d=>d.style.display!=='none')?'':'none';
    });
  });
}

/* ============ wishlist (per-device, localStorage) ============ */
const WKEY='mamave-wishlist';
function loadWish(){try{return JSON.parse(localStorage.getItem(WKEY))||[]}catch(e){return[]}}
function saveWish(w){try{localStorage.setItem(WKEY,JSON.stringify(w))}catch(e){}}
let wish=loadWish();
function wishOpen(v){document.body.classList.toggle('wish-open',v);
  if(v){document.body.classList.remove('cart-open');document.body.classList.remove('drawer-open')}}
function renderWish(){
  const badge=document.getElementById('wishCount');
  if(badge){badge.textContent=wish.length;badge.style.display=wish.length?'grid':'none'}
  const box=document.getElementById('wishItems'); if(!box)return;
  const items=wish.filter(h=>CATALOG[h]);
  box.innerHTML=items.length?items.map(h=>{
    const [name,price,img]=CATALOG[h];
    return `<div class="ci" data-wh="${h}"><img src="${img}?width=200" alt="">
      <div class="mid"><span class="n">${name}</span>
      <button class="add-mini" data-add="${h}">Add to cart</button></div>
      <div class="right"><button class="rm" aria-label="Remove">&#10005;</button><span class="p">$${price.toFixed(2)}</span></div></div>`;
  }).join(''):
  `<div class="cart-empty"><p>Nothing saved yet, mumma.<br>Tap the heart on any product to keep it here.</p>
   <svg class="squig" viewBox="0 0 64 12" aria-hidden="true"><path d="M2 8c5-6 9-6 14 0s9 6 14 0 9-6 14 0 9 6 14 0"/></svg></div>`;
  document.querySelectorAll('[data-wish]').forEach(b=>b.classList.toggle('on',wish.includes(b.dataset.wish)));
}
document.addEventListener('click',e=>{
  const wt=e.target.closest('[data-wish]');
  if(wt){e.preventDefault();const h=wt.dataset.wish;
    wish=wish.includes(h)?wish.filter(x=>x!==h):[...wish,h];
    saveWish(wish);renderWish();return}
  const rm=e.target.closest('.wish-drawer .ci .rm');
  if(rm){wish=wish.filter(x=>x!==rm.closest('.ci').dataset.wh);saveWish(wish);renderWish();return}
});
const wishBtn=document.getElementById('wishBtn');
if(wishBtn){wishBtn.addEventListener('click',()=>wishOpen(true));
  document.getElementById('wishClose').addEventListener('click',()=>wishOpen(false));
  document.getElementById('wishShopAll').addEventListener('click',e=>{e.preventDefault();wishOpen(false)});
  document.getElementById('drawerVeil').addEventListener('click',()=>wishOpen(false));
  addEventListener('keydown',e=>{if(e.key==='Escape')wishOpen(false)});
  renderWish();}

